var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"mt-5",attrs:{"cols":"6","sm":"6","md":"4","lg":"5","xl":"3"}},[_c('h3',[_vm._v("Bem-vindo "+_vm._s(_vm.$store.state.user.name)+"!")]),_c('p',[_vm._v("suas permissões: ")]),_c('pre',[_vm._v(_vm._s(_vm.$store.state.user.roles))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }